import { OutboundErrorType, OutboundStatus } from '@bechtel/ht-types';
import moment from 'moment';

export const enum Errors {
  'ALL' = 'ALL',
}

//export type ErrorTypes = Error | EventNotificationErrorTypeId;

export const enum Status {
  'ALL' = 'ALL',
  'SUCCESS'='SUCCESS',
  'ERROR'='ERROR',
  'PUBLISH'='PUBLISH'
}

//export type EventStatusTypes = Status | EventNotificationStatus;

export const enum Schedule {
  '8PM' = '8PM',
  '12AM' = '12AM',
  '6AM' = '6AM',
  'NOW' = 'NOW',
}

export const errorList = [
  { id: Errors.ALL, value: Errors.ALL, label: `All` },
  {
    id: OutboundErrorType.TRANSIENT,
    value: OutboundErrorType.TRANSIENT,
    label: `Transient`,
  },
  {
    id: OutboundErrorType.NONTRANSIENT,
    value: OutboundErrorType.NONTRANSIENT,
    label: `Non Transient`,
  },
];



export const statusList = [
  { id: Status.ALL, value: Status.ALL, label: `All` },
  { id: OutboundStatus.SUCCESS, value: OutboundStatus.SUCCESS, label: `Success` },
  { id: OutboundStatus.ERROR, value: OutboundStatus.ERROR, label: `Error` },
  { id: OutboundStatus.PUBLISH, value: OutboundStatus.PUBLISH, label: `Publish` },
];

export const scheduleList = [
  { id: Schedule['NOW'], value: Schedule['NOW'], label: `Now` },
  {
    id: Schedule['8PM'],
    value: Schedule['8PM'],
    label: `After Shift End (8PM)`,
    datetime: moment().hours(20).startOf('hour').toISOString(),
  },
  {
    id: Schedule['12AM'],
    value: Schedule['12AM'],
    label: `Midnight (12AM)`,
    datetime: moment().add(1, 'days').hours(0).startOf('hour').toISOString(),
  },
  {
    id: Schedule['6AM'],
    value: Schedule['6AM'],
    label: `Early Morning (6AM)`,
    datetime: moment().add(1, 'days').hours(6).startOf('hour').toISOString(),
  },
];

export const sortByList = [
  // {
  //   id: EventNotificationSortByTerm['CREATED_AT'],
  //   value: EventNotificationSortByTerm['CREATED_AT'],
  //   label: t`Created At`,
  // },
  // {
  //   id: EventNotificationSortByTerm['NEXT_SCHEDULE_AT'],
  //   value: EventNotificationSortByTerm['NEXT_SCHEDULE_AT'],
  //   label: t`Next Schedule At`,
  // },
  // {
  //   id: EventNotificationSortByTerm['ENTITY_TYPE_ID'],
  //   value: EventNotificationSortByTerm['ENTITY_TYPE_ID'],
  //   label: t`Entity Type Id`,
  // },
  // {
  //   id: EventNotificationSortByTerm['NOTIFICATION_TYPE_ID'],
  //   value: EventNotificationSortByTerm['NOTIFICATION_TYPE_ID'],
  //   label: t`Notification Type Id`,
  // },
  // {
  //   id: EventNotificationSortByTerm['STATUS'],
  //   value: EventNotificationSortByTerm['STATUS'],
  //   label: t`Status`,
  // },
  // {
  //   id: EventNotificationSortByTerm['UPDATED_AT'],
  //   value: EventNotificationSortByTerm['UPDATED_AT'],
  //   label: t`Updated At`,
  // },
  // {
  //   id: EventNotificationSortByTerm['RETRY_COUNT'],
  //   value: EventNotificationSortByTerm['RETRY_COUNT'],
  //   label: t`Retry Count`,
  // },
];

// export const getErrorFilter = (selectedErrorType: EventErrorTypes) => {
//   let filter: any;
//   switch (selectedErrorType) {
//     case EventNotificationErrorTypeId.TRANSIENT:
//       filter = {
//         operator: FilterOperator.EQUALS,
//         term: EventNotificationFilterByTerm.ERROR_TYPE,
//         value: EventNotificationErrorTypeId.TRANSIENT,
//       };
//       break;

//     case EventNotificationErrorTypeId.NONTRANSIENT:
//       filter = {
//         operator: FilterOperator.EQUALS,
//         term: EventNotificationFilterByTerm.ERROR_TYPE,
//         value: EventNotificationErrorTypeId.NONTRANSIENT,
//       };
//       break;
//     default:
//       break;
//   }
//   return filter;
// };

// export const getStatusFilter = (selectedStatus: EventStatusTypes) => {
//   let filter: any;
//   switch (selectedStatus) {
//     case EventNotificationStatus.SUCCESS:
//       filter = {
//         operator: FilterOperator.EQUALS,
//         term: EventNotificationFilterByTerm.STATUS,
//         value: EventNotificationStatus.SUCCESS,
//       };
//       break;

//     case EventNotificationStatus.PUBLISH:
//       filter = {
//         operator: FilterOperator.EQUALS,
//         term: EventNotificationFilterByTerm.STATUS,
//         value: EventNotificationStatus.PUBLISH,
//       };
//       break;

//     case EventNotificationStatus.ERROR:
//       filter = {
//         operator: FilterOperator.EQUALS,
//         term: EventNotificationFilterByTerm.STATUS,
//         value: EventNotificationStatus.ERROR,
//       };
//       break;
//     default:
//       break;
//   }
//   return filter;
// };
